<template>
  <div style=" width: 1200px; margin: 0 auto; background-color: #F2F6FC;  ">
<!--    <Title :title="route"></Title>-->

    <Setp :nodes="nodes" :audits="audits"></Setp>

    <el-card class="box-card" style="min-height: 650px;margin-top: 15px" shadow="never">
      <el-form label-position="left" label-width="150px">

        <el-divider content-position="left">申请人信息</el-divider>

        <el-form-item label="申请人" prop="">
          <el-input v-model="user.realName" readonly></el-input>
        </el-form-item>

        <el-form-item label="所属部门" prop="">
          <el-input v-model="user.deptName" readonly></el-input>
        </el-form-item>

        <el-divider content-position="left">报备信息</el-divider>

        <el-form-item label="报备项目" prop="projectId">
          <el-input v-model="detail.projectName" maxlength="12" readonly>
          </el-input>
        </el-form-item>

        <el-form-item label="报备类型" prop="costType">
          <el-radio-group v-model="detail.costType" style="cursor: not-allowed;pointer-events:none">
            <el-radio label="1">餐饮</el-radio>
            <el-radio label="2">烟</el-radio>
            <el-radio label="3">酒</el-radio>
            <el-radio label="4">礼品</el-radio>
            <el-radio label="5">其他</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="消费时间" prop="useTime">
          <el-date-picker
              readonly
              v-model="detail.useTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm"
              type="datetime"
              placeholder="请选择消费时间">
          </el-date-picker>

        </el-form-item>

        <el-form-item label="预估金额" prop="costMoney">
          <el-input v-model="detail.costMoney" maxlength="12" readonly>
          </el-input>
        </el-form-item>

        <el-form-item label="申请事由" prop="reportSubject">
          <el-input type="textarea" rows="5" maxlength="500" show-word-limit readonly
                    v-model="detail.reportSubject"></el-input>
        </el-form-item>

        <el-form-item label="消费人" prop="">
          <el-input v-model="detail.userName" readonly></el-input>
        </el-form-item>

        <!--        <el-form-item label="消费人" prop="useUserType" required>
                  <el-radio-group v-model="detail.useUserType" disabled>
                    <el-radio label="1">我自己</el-radio>
                    <el-radio label="2">其他人</el-radio>
                  </el-radio-group>
                </el-form-item>

                <div v-if="detail.useUserType == 2">
                  <el-form-item label="实际消费人" prop="useUser">
                    <el-select style="margin-right: 15px;" v-model="detail.useUser" placeholder="请选择实际消费人" disabled
                               filterable>
                      <el-option
                          v-for="item in userList"
                          :key="item.userId"
                          :label="item.realName"
                          :value="item.userId">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>-->
        <AuditList :audits="audits" :auditHistory="auditHistory"></AuditList>

        <!--    -->
        <div v-if="allowAudit==true">
          <el-divider content-position="left">我要审批</el-divider>


          <el-form-item label="审批意见" prop="remarks">
            <el-input type="textarea" rows="5" maxlength="500" show-word-limit
                      v-model="ruleForm.auditOpinion"></el-input>
          </el-form-item>


          <el-Form-item>
            <el-button type="primary" @click="audit(2)">审核通过</el-button>
            <el-button type="danger" @click="audit(3)">审核拒绝</el-button>
          </el-Form-item>
        </div>

      </el-form>

    </el-card>
  </div>


</template>

<script>
import Title from "../../Title";
import {requestApplyDetail, requestAudit, requestAuditShow} from "../../../api";
import Setp from "../common/Setp";
import AuditList from "../common/AuditList";

export default {
  components: {AuditList, Setp, Title},
  name: "CostReportDetail",
  props: {
    // 接收父组件传入的参数
    query: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      route: {
        name: '招待费报备详情',
        path: ''
      },
      detail: {},
      audits: [],
      auditHistory: [],
      applyId: "",
      applyServiceId: "",
      applyType: "",
      ruleForm: {
        auditOpinion: "",
      },
      user: {},
      nodes: [],
      allowAudit: false,
    }
  },
  created() {
    // this.route.path = this.$route.fullPath
    this.applyId = this.query.applyId
    this.applyServiceId = this.query.applyServiceId
    this.applyType = this.query.applyType
    this.getObject()
    this.getAuditShow()
  },
  methods: {
    getAuditShow() {
      requestAuditShow({
        applyId: this.applyId,
      }).then(res => {
        if (res.code == 200) {
          if (res.object) {
            if (res.object == 1) {
              this.allowAudit = true
            }
            if (res.object == 2) {
              this.allowAudit = false
            }
          }
        }
      })
    },
    audit(isAgree) {

      this.allowAudit = false

      if (isAgree == 2) {
        this.ruleForm.auditOpinion = "同意"
      }
      if (isAgree == 3) {
        this.ruleForm.auditOpinion = "不同意"
      }
      requestAudit({
        isAgree: isAgree,
        applyId: this.applyId,
        applyType: this.applyType,
        auditOpinion: this.ruleForm.auditOpinion,
      }).then(res => {
        if (res.code == 200) {
          this.getAuditShow()
          this.getObject()
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    getObject() {
      requestApplyDetail({
        applyId: this.applyId,
        applyServiceId: this.applyServiceId,
        applyType: this.applyType
      }).then(res => {
        if (res.code == 200) {
          if (res.object) {
            this.detail = res.object.detail
            this.audits = res.object.audits
            this.auditHistory = res.object.auditHistory
            this.user = res.object.user
            this.nodes = res.object.nodes
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    }
  }
}
</script>

<style>


</style>



